export enum SelectRecordingType {
  SCREEN = 'Screen',
  CAM = 'Cam',
  SCREEN_AND_CAM = 'Screen+Cam',
}

export enum RecordingToolAction {
  OPENED = 'Opened',
  APPLIED = 'Applied',
  CLOSED = 'Closed',
  REMOVED = 'Removed',
}
